"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var actions_1 = __importDefault(require("../../actions"));
var fullScreenDialog_1 = __importDefault(require("../../helpers/fullScreenDialog"));
var CloseIcon_1 = __importDefault(require("../../../app/components/widgets/CloseIcon"));
var ga_1 = require("../../../app/util/ga");
var format_1 = require("../../../app/util/format");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return core_1.createStyles({
        closeButton: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
        },
        headerText: {
            alignSelf: 'flex-end',
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            color: theme.palette.common.white,
        },
        headerBanner: {
            paddingBottom: theme.spacing(8),
            backgroundColor: theme.palette.primary.dark,
        },
        announcementImage: (_a = {
                width: '600px',
                height: '30vh',
                marginLeft: 'auto',
                marginRight: 'auto',
                paddingLeft: '80px',
                paddingRight: '80px',
                marginTop: theme.spacing(-6),
                marginBottom: theme.spacing(4)
            },
            _a[theme.breakpoints.down('sm')] = {
                paddingLeft: '0px',
                paddingRight: '0px',
            },
            _a),
        announcementPadding: {
            paddingBottom: theme.spacing(4),
        },
        justifyCenter: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        },
        justifyCenterImage: (_b = {
                display: 'flex',
                justifyContent: 'center',
                width: '600px'
            },
            _b[theme.breakpoints.down('sm')] = {
                width: '100%',
            },
            _b),
        message: {
            display: 'block',
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            whiteSpace: 'pre-line',
            textAlign: 'center',
        },
        closeIconButton: {
            fill: function (props) {
                return props.isFullScreenDialog ? '#BBBBBB' : theme.palette.primary.dark;
            },
            height: function (props) { return (props.isFullScreenDialog ? 44 : 30.8); },
            width: function (props) { return (props.isFullScreenDialog ? 44 : 30.8); },
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            marginLeft: function (props) {
                return props.isFullScreenDialog ? 0 : theme.spacing(2);
            },
            marginRight: function (props) {
                return props.isFullScreenDialog ? 0 : theme.spacing(2);
            },
        },
        headerWrapper: (_c = {
                background: theme.palette.background.default,
                boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.1)'
            },
            _c[theme.breakpoints.up('sm')] = {
                background: 'unset',
                boxShadow: 'unset',
            },
            _c),
        learnMoreButton: (_d = {
                // @ts-ignore
                filter: function (props) { return (props.isLightItems ? 'brightness(10)' : ''); }
            },
            // this class is not mobile first by default as padding should not be set
            // when it is not mobile.
            _d[theme.breakpoints.down('xs')] = {
                paddingLeft: 0,
                paddingRight: 0,
                minWidth: theme.spacing(6),
            },
            _d.width = theme.spacing(16),
            _d.marginTop = theme.spacing(3),
            _d.backgroundColor = theme.palette.primary.dark,
            _d.color = theme.palette.background.default,
            _d['&:hover'] = {
                backgroundColor: theme.palette.primary.main,
            },
            _d),
        modalBottom: {
            marginBottom: theme.spacing(8),
        },
    });
});
var AnnouncementModal = function () {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var dispatch = react_redux_1.useDispatch();
    var isFullScreenDialog = fullScreenDialog_1.default();
    var classes = useStyles({ isFullScreenDialog: isFullScreenDialog });
    var _b = __read(react_1.useState(false), 2), showModal = _b[0], setShowModal = _b[1];
    var announcement = react_redux_1.useSelector(function (state) { return state.user.announcement; });
    react_1.useEffect(function () {
        var getUserAnnouncement = function () {
            return dispatch(actions_1.default.getUserAnnouncement());
        };
        if (announcement === null) {
            getUserAnnouncement();
        }
        else {
            var announcementString = JSON.stringify(announcement);
            var previousAnnouncement = localStorage.getItem('announcement');
            if (previousAnnouncement !== announcementString) {
                localStorage.setItem('announcement', announcementString);
                var hasAnnouncement = Boolean(announcement.message ||
                    announcement.title ||
                    announcement.subtitle ||
                    announcement.url ||
                    announcement.image);
                setShowModal(hasAnnouncement);
            }
        }
    }, [announcement, dispatch]);
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": "userModal", "aria-describedby": "user-modal", fullScreen: isFullScreenDialog, fullWidth: !isFullScreenDialog, maxWidth: "md", open: showModal, onClose: function () { return setShowModal(false); } },
        (announcement === null || announcement === void 0 ? void 0 : announcement.image) || (announcement === null || announcement === void 0 ? void 0 : announcement.title) ? (react_1.default.createElement("div", { className: classes.headerBanner },
            react_1.default.createElement("div", { className: classes.closeButton },
                react_1.default.createElement("div", null),
                react_1.default.createElement(core_1.IconButton, { className: classes.closeIconButton, onClick: function () { return setShowModal(false); }, size: "small" },
                    react_1.default.createElement(CloseIcon_1.default, { size: isFullScreenDialog ? 36 : 24 }))),
            react_1.default.createElement("div", { className: classes.justifyCenter }, (announcement === null || announcement === void 0 ? void 0 : announcement.title) ? (react_1.default.createElement(core_1.Typography, { className: classes.headerText, variant: isFullScreenDialog ? 'h6' : 'h3' }, announcement.title)) : null))) : (react_1.default.createElement("div", { className: classes.closeButton },
            react_1.default.createElement("div", null),
            react_1.default.createElement(core_1.IconButton, { className: classes.closeIconButton, onClick: function () { return setShowModal(false); }, size: "small" },
                react_1.default.createElement(CloseIcon_1.default, { size: isFullScreenDialog ? 36 : 24 })))),
        (announcement === null || announcement === void 0 ? void 0 : announcement.image) ? (react_1.default.createElement("img", { className: classes.justifyCenterImage + " " + classes.announcementImage, alt: "announcement", src: announcement.image })) : (react_1.default.createElement("div", { className: classes.justifyCenterImage + " " + classes.announcementPadding })),
        (announcement === null || announcement === void 0 ? void 0 : announcement.subtitle) ? (react_1.default.createElement(core_1.Typography, { className: classes.headerText + " " + classes.justifyCenter, variant: "h6", color: "primary" }, announcement.subtitle)) : null,
        (announcement === null || announcement === void 0 ? void 0 : announcement.message) ? (react_1.default.createElement(core_1.Typography, { className: classes.message, variant: "body2", dangerouslySetInnerHTML: {
                // Enable line break
                __html: format_1.htmlSanitizer(announcement.message.replace(/\\n/g, '\n')),
            } })) : null,
        react_1.default.createElement("div", { className: classes.justifyCenter + " " + classes.modalBottom }, (announcement === null || announcement === void 0 ? void 0 : announcement.url) ? (react_1.default.createElement(core_1.Button, { href: announcement.url, target: "_blank", color: "primary", size: "large", variant: "text", className: classes.learnMoreButton, onClick: function () {
                ga_1.GAEvent('Announcement Page', (announcement === null || announcement === void 0 ? void 0 : announcement.title) || 'successful');
            } }, t('button.tryItNow'))) : null)));
};
exports.default = AnnouncementModal;
